module.exports = __webpack_public_path__ + "img/7772823.png";